
    import { defineComponent, SetupContext, PropType } from 'vue'
    import { ItemsFooter } from '@/types/webchatFooter'

    import Icon from '@/components/Icon/IndexIcon.vue'

    interface SetupReturn {
        emit: SetupContext['emit']
    }

    export default defineComponent({
        emits: ['update'],

        components: { Icon },

        props: {
            items: {
                type: Array as PropType<ItemsFooter[]>,
                default: () => []
            }
        },

        setup (_, { emit }: SetupContext): SetupReturn {
            return {
                emit
            }
        }
    })
